export default "__VITE_ASSET__DgUvsYZJ__"